import { useParams } from 'react-router-dom';
import History from '~/utils/history';
import CategoryContainer from '~/containers/CategoryContainer/CategoryContainer';
import { urlsMap } from '~/utils/menu';
import { useSelector } from 'react-redux';
import { State } from '~/Reducers';
import { IRoutingStateSelector, routingStateSelector } from '~/routing/routingState';
import equal from 'fast-deep-equal/react';
import { isCategoryDisabledForUser } from '~/routing/helpers';

export default function CategoryRouter() {
    const { categoryName, id } = useParams();
    const { categories } = useSelector<State, IRoutingStateSelector>(routingStateSelector, equal);

    if (isCategoryDisabledForUser(categoryName, id, categories)) {
        History.navigate(urlsMap.home, { replace: true });
        return null;
    }

    return <CategoryContainer params={{ categoryName, id }} />;
}
